import { render } from "./TreeItemsCheckboxes.vue?vue&type=template&id=4710ba4a&scoped=true"
import script from "./TreeItemsCheckboxes.vue?vue&type=script&lang=js"
export * from "./TreeItemsCheckboxes.vue?vue&type=script&lang=js"

import "./TreeItemsCheckboxes.vue?vue&type=style&index=0&id=4710ba4a&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4710ba4a"]])

export default __exports__